<template>
    <modal name="privacy-policy" class="dd-m-modal dd-m-modal--offline">
        <button v-on:click="hide()" type="button" class="dd-m-modal--offline__close-btn">
            <i class="dd-m-icon icon-close"></i>
        </button>

        <div class="dd-m-modal--offline__content">
            <privacy-policy :close="toggle"></privacy-policy>
        </div>
    </modal>
</template>
<script>
    import PrivacyPolicy from "./privacy-policy";

    export default {
        name: 'modal-privacy-policy',
        components: {PrivacyPolicy},
        mounted() {
            this.subscribe();
        },
        methods: {
            subscribe() {
                PubSub.subscribe('togglePrivacyModal', (msg, param) => {
                    this.toggle(param);
                });
            },
            toggle(param) {
                param ? this.show() : this.hide();
            },
            show() {
                this.$modal.show('privacy-policy');
            },
            hide() {
                this.$modal.hide('privacy-policy');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/pages/privacy-policy/modal-privacy-policy.vue